export default __webpack_public_path__ + "static/media/grafema_ummi_08.e0d463d7.jpg";